export const MODAL__ACTIONS = {
  OPEN: "OPEN",
};

export const AUTHENTICATION__ACTIONS = {
  LOGIN: "LOGIN",
  RESET: "RESET",
  CODEVERIFY: "CODEVERIFY",
  REGISTER: "REGISTER",
  VERIFYACCOUNT: "VERIFYACCOUNT",
  PASSRESET: "PASSRESET",
  LOGOUT: "LOGOUT",
  SUBMITOTP: "SUBMITOTP",
  SENDREGISTEROTP: "SENDREGISTEROTP",
  FORGETPASSWORDCODE: "FORGETPASSWORDCODE",
  SENTFORGETPASSOTP: "SENTFORGETPASSOTP",
  FORGETPASSWORDRESET: "FORGETPASSWORDRESET",
};

export const LOGOUT__DIALOG__ACTIONS = {
  SHOWDIALOG: "SHOWDIALOG",
  HIDEDIALOG: "HIDEDIALOG",
};

export const MAM__WALLET__ACTIONS = {
  WALLETTRANSACTIONHISTORY: "WALLETTRANSACTIONHISTORY",
  USERMAMWALLETSUMMARY: "USERMAMWALLETSUMMARY",
  INVESTORWALLETHISTORY: "INVESTORWALLETHISTORY",
  MANAGERWALLETHISTORY: "MANAGERWALLETHISTORY",
  MAMWALLETINTERNALTRANSFERACCOUNT: "MAMWALLETINTERNALTRANSFERACCOUNT",
  WALLETINTERNALTRANSFERCODE: "WALLETINTERNALTRANSFERCODE",
  CONFIRMWALLETINTERNALTRANSFER: "CONFIRMWALLETINTERNALTRANSFER",
  MAMWALLETWITHDRAWCODE: "MAMWALLETWITHDRAWCODE",
  CONFIRMMAMWALLETWITHDRAW: "CONFIRMMAMWALLETWITHDRAW",
}

export const PROFILE__ACTIONS = {
  GETPROFILE: "GETPROFILE",
  CHANGE_PROFILE_URL: "CHANGE_PROFILE_URL",
  UPDATEPROFILEINFO: "UPDATEPROFILEINFO",
  GETPROFILESTATUS: "GETPROFILESTATUS",
  FETCHDOCUMENTS: "FETCHDOCUMENTS",
  IDENTITYVERIFICATION: "IDENTITYVERIFICATION",
  RESIDENCEVERIFICATION: "RESIDENCEVERIFICATION",
  BECOMEANIB: "BECOMEANIB",
  ACCOUNTSUMMARY: "ACCOUNTSUMMARY",
  LIVETRADES: "LIVETRADES",
  DELETEDOCUMENT: "DELETEDOCUMENT",
  PROFITLOSS:"PROFITLOSS",
  CHANGETHEME: "CHANGETHEME",
  POPUPNOTICE: "POPUPNOTICE",

    //2factor
  TWOFA_START: "TWOFA_START",
  TWOFA_ENABLE: "TWOFA_ENABLE",
  TWOFA_DISABLE: "TWOFA_DISABLE",
  TWOFA_ACTIVATE: "TWOFA_ACTIVATE",
};

export const BANK__INFORMATION__ACTIONS = {
  GETBANKINFORMATIONS: "GETBANKINFORMATIONS",
  ADDNEWBANKACCOUNT: "ADDNEWBANKACCOUNT",
  UPDATEBANKINFORMATIONS: "UPDATEBANKINFORMATIONS",
  DELETEBANKACCOUNT: "DELETEBANKACCOUNT",
};

export const CRYPTO__ACTIONS = {
  GETALL: "GETALL",
  DETAILS: "DETAILS",
  CREATE: "CREATE",
  NETWORKS: "NETWORKS",
  OVYPAY: "OVYPAY",
  DELETECRYPTO: "DELETECRYPTO",
  DELETECRYPTO: "DELETECRYPTO",
  SENDOTP: "SENDOTP",
  CODEVERIFY: "CODEVERIFY",
};

export const AGREEMENT__ACTIONS = {
  NOTACCEPTEDAGREEMENTS: "NOTACCEPTEDAGREEMENTS",
  AGREEMENTHISTORIES: "AGREEMENTHISTORIES",
  UPLOADAGREEMENTFILE: "UPLOADAGREEMENTFILE",
};

export const PANEL_SWITCHER_ACTIONS = {
  SWITCH_TO_PARTNER: 'SWITCH_TO_PARTNER'
};

export const BANK__ACTIONS = {
  GETALL: "GETALL",
  DETAILS: "DETAILS",
  CREATE: "CREATE",
  DELETEBANK: "DELETEBANK"
};

export const COUNTRIES__ACTIONS = {
  COUNTRIES: "COUNTRIES",
};

export const CITIES__ACTIONS = {
  CITIES: "CITIES",
};

export const STATES__ACTIONS = {
  STATES: "STATES",
};

export const FAQS__ACTIONS = {
  FAQS: "FAQS",
};

export const COMPANYINFO__ACTIONS = {
  COMPANYINFO: "COMPANYINFO",
};

export const TICKETS__ACTIONS = {
  TICKETS: "TICKETS",
  DETAILS: "DETAILS",
  CREATE: "CREATE",
  REPLY: "REPLY",
};

export const TRADING__ACTIONS = {
  CLIENTLIVETRADES: "CLIENTLIVETRADES",
  LEVERAGES: "LEVERAGES",
  LEVERAGEACCOUNTTYPE: "LEVERAGEACCOUNTTYPE",
  ACCOUNTTYPES: "ACCOUNTTYPES",
  OPENTRADINGACCOUNT: "OPENTRADINGACCOUNT",
  LIVEACCOUNTS: "LIVEACCOUNTS",
  DEMOACCOUNTS: "DEMOACCOUNTS",
  MT5ACCOUNTDETAILS: "MT5ACCOUNTDETAILS",
  TRADEHISTORY: "TRADEHISTORY",
  ALLTRADEDETAILS: "ALLTRADEDETAILS",
  TOTALLIVEACCOUNTS: "TOTALLIVEACCOUNTS",
  DEMOACCOUNTTYPES: "DEMOACCOUNTTYPES",
  OPENNEWDEMOACCOUNT: "OPENNEWDEMOACCOUNT",
  LIVETRADINGACCOUNTS: "LIVETRADINGACCOUNTS",
  INVESTORACCOUNTLIVETRADES: "INVESTORACCOUNTLIVETRADES",
  INVESTORACCOUNTTRADEHISTORY: "INVESTORACCOUNTTRADEHISTORY",
  MANAGERACCOUNTBALANCECARDDETAILS: "MANAGERACCOUNTBALANCECARDDETAILS",
  VIEWMANAGERDETAILS: "VIEWMANAGERDETAILS",
};

export const TRANSACTION__ACTIONS = {
  TRANSACTIONHISTORY: "TRANSACTIONHISTORY",
  RECENTTRANSACTIONHISTORY: "RECENTTRANSACTIONHISTORY",
  TRADERTRANSACTIONS: "TRADERTRANSACTIONS",
  PAYMENTMETHOD: "PAYMENTMETHOD",
  ACCOUNTSTODEPOSIT: "ACCOUNTSTODEPOSIT",
  //deposit
  CASHDEPOSIT: "CASHDEPOSIT",
  BANKDEPOSIT: "BANKDEPOSIT",
  CARDDEPOSIT: "CARDDEPOSIT",
  //withdraw
  SENDCODE: "SENDCODE",
  CASHWITHDRAW: "CASHWITHDRAW",
  CARDWITHDRAW: "CARDWITHDRAW",
  BANKWITHDRAW: "BANKWITHDRAW",
  INTERNALTRANSFERACCOUNT: "INTERNALTRANSFERACCOUNT",
  INTERNALTRANSFERCODE: "INTERNALTRANSFERCODE",
  CONFIRMINTERNALTRANSFER: "CONFIRMINTERNALTRANSFER",
};

export const MAM__ACTIONS = {
  INVESTORMANAGERACCOUNT: "INVESTORMANAGERACCOUNT",
  MANAGERLISTS: "MANAGERLISTS",
  OPENNEWINVESTORACCOUNT: "OPENNEWINVESTORACCOUNT",
  ACCOUNTTYPESANDLEVERAGES: "ACCOUNTTYPESANDLEVERAGES",
  STUSERNAMES: "STUSERNAMES",
  OPENNEWMANAGERACCOUNT: "OPENNEWMANAGERACCOUNT",
  MYMANAGERACCOUNTS: "MYMANAGERACCOUNTS",
  MYINVESTORACCOUNTS: "MYINVESTORACCOUNTS",
  LIVETRADESMANAGERINVESTOR: "LIVETRADESMANAGERINVESTOR",
  MANAGERACCOUNTDETAILS: "MANAGERACCOUNTDETAILS",
  UPDATEACTIVESTATUS: "UPDATEACTIVESTATUS",
  REMOVEINVESTOR: "REMOVEINVESTOR",
  LIVEORDERSMANAGERINVESTORS: "LIVEORDERSMANAGERINVESTORS",
  ORDERHISTORYMANAGERINVESTORS: "ORDERHISTORYMANAGERINVESTORS",
  MANAGERACTIVERUNNINGORDERDETAILS: "MANAGERACTIVERUNNINGORDERDETAILS",
};

export const PLATFORMS__ACTIONS = {
  DOWNLOADPLATFORMS: "DOWNLOADPLATFORMS",
};

export const LEVERAGE__ACTIONS = {
  USERLEVERAGE: "USERLEVERAGE",
  ALLLEVERAGES: "ALLLEVERAGES",
  UPDATELEVERAGE: "UPDATELEVERAGE",
  UPDATEMT5PASSWORD: "UPDATEMT5PASSWORD",
};

export const CHARTS__ACTIONS = {
  PROFITLOSSCHARTHISTORY: "PROFITLOSSCHARTHISTORY",
  CLOSEDTRADESPROFITLOSSCHARTHISTORY: "CLOSEDTRADESPROFITLOSSCHARTHISTORY",
  DASHBOARDPROFITLOSSCHARTHISTORY: "DASHBOARDPROFITLOSSCHARTHISTORY",
  SINGLEACCOUNTPROFITLOSSSUMMARY: "SINGLEACCOUNTPROFITLOSSSUMMARY",
  MANAGERINVESTORPROFITLOSSCHART: "MANAGERINVESTORPROFITLOSSCHART",
  MANAGERINVESTORBUYSELLCHART: "MANAGERINVESTORBUYSELLCHART",
};

export const ACCOUNT__ACTIONS = {
  ACCOUNTNO: "ACCOUNTNO",
};

export const NOTIFICATIONS__ACTIONS = {
  NOTIFICATIONS: "NOTIFICATIONS",
  MARK_ALL_AS_READ: "MARK_ALL_AS_READ",
  SET_POLLING_INTERVAL: "SET_POLLING_INTERVAL",
  STOP_POLLING_INTERVAL: "STOP_POLLING_INTERVAL",
  UPDATE: "UPDATE"
};


export const DEPOSITMETHODS__ACTIONS = {
  DEPOSITMETHODS: "DEPOSITMETHODS",
  DEPOSITACCOUNTS: "DEPOSITACCOUNTS",
  BROKERSBANK: "BROKERSBANK",
  CREATEBANKDEPOSIT: "CREATEBANKDEPOSIT",
  CREATECASHDEPOSIT: "CREATECASHDEPOSIT",
  CREATECRYPTODEPOSIT: "CREATECRYPTODEPOSIT",
  CREATEGPAYDEPOSIT: "CREATEGPAYDEPOSIT",
  GETPAYMENTSYSTEM: "GETPAYMENTSYSTEM",
  CREATECARDDEPOSIT: "CREATECARDDEPOSIT",
  NEEDSLIP: "NEEDSLIP",
  INRRATE: "INRRATE",
  CREATECRYPTODEPOSITOVIPAYQR: "CREATECRYPTODEPOSITOVIPAYQR",
  CHECKCRYPTODEPOSITOVIPAY: "CHECKCRYPTODEPOSITOVIPAY",
  PAYMENTNOTIFICATION: "PAYMENTNOTIFICATION",
  PAYMENTLOG: "PAYMENTLOG",
};

export const WITHDRAWMETHODS__ACTIONS = {
  WITHDRAWMETHODS: "WITHDRAWMETHODS",
  WITHDRAWACCOUNTS: "WITHDRAWACCOUNTS",
  WITHDRAWOTP: "WITHDRAWOTP",
  BROKERSBANK: "BROKERSBANK",
  CREATEBANKWITHDRAW: "CREATEBANKWITHDRAW",
  CREATECASHWITHDRAW: "CREATECASHWITHDRAW",
  CREATECRYPTOWITHDRAW: "CREATECRYPTOWITHDRAW",
  USERCRYPTOADDRESS: "USERCRYPTOADDRESS",
  INRRATE: "INRRATE",
  OTPVIA: "OTPVIA",
};

export const PUBLIC_LOGIN__ACTIONS = {
  LOGINPAGEINFO: "LOGINPAGEINFO",
  TERMSANDCONDITIONLINK: "TERMSANDCONDITIONLINK",
  COUNTRIES: "COUNTRIES"
};
 
export const TRADABLEBONUS__ACTIONS = {
  CREATETRADABLEBONUSACCOUNT: "CREATETRADABLEBONUSACCOUNT",
  TRADABLEBONUSACCOUNTINFO: "TRADABLEBONUSACCOUNTINFO",
};

export const NOMINEE__ACTIONS = {
  FETCH_NOMINEES: "FETCH_NOMINEES",
  CREATE_NOMINEE: "CREATE_NOMINEE",
  UPDATE_NOMINEE: "UPDATE_NOMINEE",
  SHOW_NOMINEE: "SHOW_NOMINEE",
};
